import React, { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";
import "../../assets/css/scss/component/authentication/_comingSoonSection.scss";
import { isMobileOnly } from "react-device-detect";
import Countdown from "react-countdown";

export default function ComingSoonSection(props: any) {
    let defaultImageName =
        "/assets/images/" +
        (isMobileOnly
            ? `auth-background-${Math.floor(Math.random() * 3) + 1}.jpg`
            : `auth-background-mobile-${Math.floor(Math.random() * 3) + 1}.jpg`);
    const [imageName, setImageName] = useState(defaultImageName);
    const headerContainer = document.getElementById("header-container")?.getBoundingClientRect();

    // setTimeout(() => {
    //     console.log("jjjjjjjjjjjjj")
    //     setImageName(
    //         "/assets/images/" +
    //         (isMobileOnly
    //             ? `auth-background-mobile-${Math.floor(Math.random() * 3) + 1
    //             }.jpg`
    //             : `auth-background-${Math.floor(Math.random() * 3) + 1
    //             }.jpg`)
    //     );
    // }, 20000);
    const Completionist = () => <span>You are good to go!</span>;
    const renderer = (data: any) => {
        console.log(">>rendere", data);
        if (data?.formatted?.completed) {
            // Render a completed state
            if (props?.refresh) {
                props.refresh()
            }
            return <Completionist />;
        } else {
            // Render a countdown
            // return <span>{data?.formatted?.days}:{data?.formatted?.hours}:{data?.formatted?.minutes}:{data?.formatted?.seconds}</span>;
            return <>
                <ul>
                    <li>{data?.formatted?.days}</li>
                    <li className="font-24">Days</li>
                </ul>
                <ul>
                    <li>{data?.formatted?.hours}</li>
                    <li className="font-24">Hrs</li>
                </ul>
                <ul>
                    <li>{data?.formatted?.minutes}</li>
                    <li className="font-24">Min</li>
                </ul>
                <ul>
                    <li>{data?.formatted?.seconds}</li>
                    <li className="font-24">Sec</li>
                </ul>
            </>
        }
    };


    return (
        <div
            className="comingsoon-sidebar d-flex flex-column justify-content-between align-items-center"
            style={{
                backgroundImage: `url(${imageName})`,
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundBlendMode: "luminosity",
                height: window.innerHeight + "px",
                width: "auto"
            }}
        >
            <div className="d-flex align-items-center justify-content-center" style={{ height : "100%"}}>
                <div>
                    <h1>Coming Soon</h1>
                    {props?.maintenanceTime ?
                        <h1><Countdown date={new Date(props.maintenanceTime).getTime()} renderer={renderer} /></h1>
                        : null}
                </div>
            </div>
            {/* <div className="bottom-card d-none d-md-block">
        <h3 className="font-semibold theme-dark-white">Get Started</h3>
        <button
          className="btn btn-fb d-flex align-items-center justify-content-center"
          onClick={() => login()}
        >
          <span>Sign Up with Google <FcGoogle /></span>
        </button>
      </div> */}
        </div>
    );
}
